import React, { useEffect } from 'react';

const ScannerControl = ({ radius, setRadius, onScan, loading, maxRadius = 50000 }) => {
  // Clamp radius to maxRadius when maxRadius loads/changes
  useEffect(() => {
    if (radius > maxRadius) setRadius(maxRadius);
  }, [maxRadius]);

  return (
    <div style={{
      background: 'rgba(5, 7, 10, 0.8)',
      border: '1px solid var(--nasa-blue)',
      padding: '15px',
      borderRadius: '4px',
      backdropFilter: 'blur(10px)',
      width: '100%',
      marginBottom: '15px'
    }}>
      <h4 style={{ 
        color: 'var(--tech-cyan)', 
        margin: '0 0 10px 0', 
        fontSize: '12px', 
        letterSpacing: '2px',
        textTransform: 'uppercase'
      }}>Area Scanner</h4>
      
      <div style={{ marginBottom: '15px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: '5px',
          fontSize: '11px',
          fontFamily: 'monospace',
          color: 'var(--tech-cyan)'
        }}>
          <span>RANGE</span>
          <span>{radius}m / max {maxRadius >= 1000 ? `${maxRadius / 1000}km` : `${maxRadius}m`}</span>
        </div>
        <input 
          type="range" 
          min="100" 
          max={maxRadius} 
          step="50" 
          value={radius} 
          onChange={(e) => setRadius(parseInt(e.target.value))}
          style={{ 
            width: '100%', 
            cursor: 'pointer',
            accentColor: 'var(--tech-cyan)',
            height: '4px',
            background: 'rgba(255, 255, 255, 0.1)'
          }}
        />
      </div>

      <button 
        className="nasa-button" 
        onClick={onScan} 
        disabled={loading}
        style={{ 
          width: '100%', 
          fontSize: '11px', 
          padding: '8px',
          opacity: loading ? 0.5 : 1,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'ANALYZING...' : 'INITIATE SCAN'}
      </button>
    </div>
  );
};

export default ScannerControl;
